/* Page shown when the project slug is missing or invalid */
import React from "react";
import styles from "../../styles/PageNotFound.module.css";
import Asset from "../../components/Asset";
import NoResults from "../../assets/no-results.png";

const InvalidProjectPage = () => {
  return (
    <div className={styles.margin}>
      <h2 className="mb-4 text-center">Project name is not available</h2>
      <Asset
        src={NoResults}
        message="Please use the proper project URL and contact your Production Manager."
      />
    </div>
  );
};

export default InvalidProjectPage;
